import preloader from "./preloader";
import ScrollTrigger from "gsap/ScrollTrigger";
import gsap from "gsap";
import popup from "./popup";
gsap.registerPlugin(ScrollTrigger)

window.onload = function(){
    preloader()
    init()
}

function init() {
  scrollReveal()
  popup()
}

function scrollReveal(){
    const scrollReveal = document.querySelectorAll('.scroll-reveal')
      scrollReveal.forEach((item)=>{
        gsap.timeline({
          scrollTrigger: {
            trigger: item,
            toggleActions: 'play none none reverse',
            // markers: true,
            start: 'top bottom-=10%',
          }
        })
        .from(item, {opacity: 0, y: 50, delay: .2 })
      })
  }

  const videos = document.querySelectorAll('.keep-video-ratio')
  setHeight()
  
  window.addEventListener('resize', ()=>setHeight())
  
  function setHeight(){
    videos.forEach(video => {
      const vidEl = video.querySelector('video')
      const vidHeight = vidEl.offsetHeight
      console.log(vidHeight)
      setTileSize(video, vidHeight)
    })
  }
  
  function setTileSize(element, vidHeight){
    const delta = window.innerWidth > 576 ? 15 : 5;
  
    element.style.height = Math.floor(vidHeight - delta) - 1 + 'px'
    element.style.minHeight = Math.floor(vidHeight - delta) - 1 + 'px'
  }